import { useContext } from "react";
import { useSelector } from "react-redux";
import { ChatConversation, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestPending: boolean;
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  conversations: Identifiable<ChatConversation>[];
  retrieveConversations(): void;
}

function useRetrieveConversations(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveConversationsRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveConversationsRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveConversationsRequestFailure,
    ),
    conversations: useSelector(selector.getChatConversations),
    retrieveConversations: core.retrieveConversations,
  };
}

export { useRetrieveConversations };
